import { z } from "zod";


export const ContasReceberCopiaSchema = z.object({
    idContaReceber: z.coerce.number().min(1, { message: "Selecione uma conta a receber" }),
    dataRecebimento: z.coerce.date({ invalid_type_error: "Data de recebimento inválida." }),
    titulo: z.coerce.string().optional(),
    tipoData: z.coerce.number().refine((val) => [0, 1, 2].includes(val), {
        message: "Tipo de data inválida.",
    }).default(0),
    nroCopias: z.coerce.number().min(1, { message: "Número de cópias inválido." })
        .max(50, { message: "Número máximo de cópias é 50." }),

});

export type ContasReceberCopiaForm = z.infer<typeof ContasReceberCopiaSchema>;

export const defaultContasReceberCopiaForm: Partial<ContasReceberCopiaForm> = {
    dataRecebimento: new Date(),
    tipoData: 0,
    nroCopias: 1,

}